
import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter, NgModule, HostListener, Renderer2, ViewChildren, Directive } from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { SearchService } from 'src/app/services/search.service';
import { WpapiService } from 'src/app/services/wpapi.service';
import { Title } from '@angular/platform-browser';
import { RelatedService } from 'src/app/services/related.service';
import { PageService } from 'src/app/services/page.service';
import { ReturnAnimation } from 'src/app/interfaces/returnanimation.interface';
import { AnimationService } from 'src/app/services/animation.service';
import { fadeAnimationResponsive, fadeAnimation, fadeHeaderAnimation } from 'src/app/animations/animation';
import { Menu } from 'src/app/interfaces/menu.interface';
import { Reels } from 'src/app/interfaces/reels.interface';
import { Subscription } from 'rxjs';
import { ThemeService } from 'src/app/services/theme.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    animations: [fadeAnimationResponsive, fadeHeaderAnimation, fadeAnimation]
})
export class HeaderComponent implements OnInit {
    values = '';
    @ViewChild('searchbox') searchbox: ElementRef;
    @ViewChild('toggleButton') toggleButton: ElementRef;
    @ViewChild('connectButton') connectButton: ElementRef;
    @ViewChild('menu') menu: ElementRef;
    @Output() onFilter: EventEmitter<any> = new EventEmitter();
    menuToggle = false;
    contactItems: any;
    ActiveFirst = false;
    ActiveSecond = false;
    ActiveThird = false;
    ActiveFourth = false;
    ActiveFifth = false;
    ActiveSix = false;
    ActiveSeven = false;
    ActiveEight = false;
    ActiveNine = false;
    ActiveTen = false;
    ActiveEleven = false;
    ActiveTwelve = false;
    ActiveThirteen = false;
    ActiveFourteen = false;
    careersActive = false;
    inquiresActive = false;
    socialActive = false;
    activeContactInfo = false;
    companySliderActive = true;
    returnanimations: ReturnAnimation[] = [];
    body = document.getElementsByTagName('body')[0];
    location = window.location;
    navmenu = document.getElementsByClassName('nav-el');
    navmenuhome = document.getElementsByClassName('nav-home');
    categories: any;
    categoriesmobile: any;
    setActiveFilter: string = 'all work';
    activeAll: string = 'all';
    hiddeLogo: boolean = false;
    showcatgories: boolean = false;
    showBackButton: boolean = false;
    showExitVideoButton: boolean = false;
    removeBgColor: boolean = true;
    removeBgColorDesktop: boolean = true;
    removeReelsBgColor: boolean = true;
    removeReelsBgColorDesktop: boolean = true;
    toggleDropdown: boolean = false;
    screenWidth: number = 0;
    fadeContentMenus: boolean = false;
    preloadmenus: Menu[] = [];
    menus: Menu[] = [];
    socials: Menu[] = [];
    reels: Reels[];
    showReels: boolean = false;
    activeReelNumber: number = 0;
    connect: any;
    fadeContentLink: boolean = false;
    fadeContent: boolean = false;
    fadeContentLinkS: boolean = false;
    openMobileMenu: boolean = false;
    whiteLogo: boolean = false;
    bannerActive: boolean = true;
    changeLogo: boolean = false;
    loadMenu: boolean = false;
    loadPulla: boolean = false;
    whiteLoadMenu: boolean = false;
    rotateValue: number = 0;
    logo = document.getElementById('rotate-logo');
    showSingleWorkTitle: boolean = false;
    singleWork: any;
    menuDisabled: boolean = true;
    showSearch: boolean = false;
    fadeSearch: boolean = false;
    searchText: string = "";
    searchModel: any;
    searchingOnFocus: boolean = false;
    worksTopBar: boolean = false;
    activateMenuOverlay: boolean = false;
    subscription: Subscription;
    companyLogoColor: boolean = false;
    isIPadPro = /Macintosh/.test(navigator.userAgent) && 'ontouchend' in document;
    content: any;
    activeImage: number = 0;
    activeMenuItem: number = 0;
    public categoryParams = {
        id: null,
        slug: null,
    }
    darkTheme: boolean = false;

    constructor(private route: ActivatedRoute,
        private router: Router,
        private searchService: SearchService,
        private animationService: AnimationService,
        private pageService: PageService,
        private titleService: Title,
        private wpApi: WpapiService,
        private theme: ThemeService) {
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.toggleCategoriesDropdownEventMobile();
                var url = event.url;
                var slash = '/';
                if (url.indexOf(slash) != url.lastIndexOf(slash)) {
                    url = url.substring(0, url.lastIndexOf("/") + 1);
                }
                switch (url) {
                    case '/':
                        if (this.screenWidth <= 1024) {
                            setTimeout(() => {
                                this.whiteLogo = true;
                            }, 300);
                        } else {
                            this.whiteLogo = false;
                        }
                        setTimeout(() => {
                            this.activeImage = 0;
                            this.activeMenuItem = 0;
                        }, 3000);
                        this.removeBgColor = true;
                        this.removeBgColorDesktop = false;
                        this.worksTopBar = false;
                        if (document.getElementById('main-container-wrapper').classList.contains('is-full')) {
                            document.getElementById('main-container-wrapper').classList.remove('is-full');
                        }
                        break;

                    case '/company':
                        setTimeout(() => {
                            this.activeImage = 2;
                            this.activeMenuItem = 2;
                        }, 3000);
                        this.removeBgColor = true;
                        this.removeBgColorDesktop = true;
                        this.worksTopBar = false;
                        document.getElementById('main-container-wrapper').classList.add('is-full');
                        break;

                    // case '/reels':
                    //     setTimeout(() => {
                    //         this.activeImage = 3;
                    //         this.activeMenuItem = 3;
                    //     }, 3000);
                    //     if (this.screenWidth <= 1024) {
                    //         this.whiteLogo = true;
                    //     } else {
                    //         this.whiteLogo = false;
                    //     }
                    //     this.removeBgColor = true;
                    //     this.removeBgColorDesktop = false;
                    //     this.worksTopBar = false;
                    //     this.activeReelNumber = 0;
                    //     if (document.getElementById('main-container-wrapper').classList.contains('is-full')) {
                    //         document.getElementById('main-container-wrapper').classList.remove('is-full');
                    //     }
                    //     break;

                    case '/works/':
                        setTimeout(() => {
                            this.activeImage = 1;
                            this.activeMenuItem = 1;
                        }, 3000);
                        if (this.screenWidth <= 1024) {
                            this.whiteLogo = false;
                            this.removeBgColor = false;
                            this.removeBgColorDesktop = false;
                            document.getElementById('main-container-wrapper').classList.add('is-full');
                        }
                        this.worksTopBar = false;
                        break;

                    case '/works':
                        setTimeout(() => {
                            this.activeImage = 1;
                            this.activeMenuItem = 1;
                        }, 3000);
                        this.whiteLogo = false;
                        this.removeBgColor = false;
                        this.removeBgColorDesktop = false;
                        this.worksTopBar = true;
                        if (document.getElementById('main-container-wrapper').classList.contains('is-full')) {
                            document.getElementById('main-container-wrapper').classList.remove('is-full');
                        }
                        break;
                    case '/connect':
                        console.log('case connect');
                        
                        setTimeout(() => {
                            this.activeImage = 3;
                            this.activeMenuItem = 3;
                        }, 3000);
                        this.removeBgColor = true;
                        this.removeBgColorDesktop = true;
                        this.worksTopBar = false;
                        document.getElementById('main-container-wrapper').classList.add('is-full');
                        break;
                    default:
                        break;
                }
                if (event.url == '/works' || event.url.includes('/works?')) {
                    this.getCatgories();
                    if (window.location.pathname === '/works') {
                        var url = window.location.href;
                        var query_string_paramter = url.split("?")[1];
                        if (query_string_paramter) {
                            if (query_string_paramter.includes('search')) {
                                var search = query_string_paramter.replace('search=', '');
                                this.setActiveFilter = 'all work';
                                this.activeAll = 'all work';
                                this.showSearch = true;
                                setTimeout(() => {
                                    this.fadeSearch = true;
                                }, 300);
                                this.searchModel = search;
                                this.searchText = search;
                            } else if (!query_string_paramter.includes('category')) {
                                this.setActiveFilter = 'all work';
                                this.activeAll = 'all work';
                            } else {
                                var parameter = query_string_paramter.replace('category=', '');
                                this.setActiveFilter = parameter;
                                this.activeAll = parameter;
                            }
                        } else {
                            this.setActiveFilter = 'all work';
                            this.activeAll = 'all work';
                        }
                        this.whiteLogo = false;
                        this.removeBgColor = false;
                        this.removeBgColorDesktop = false;
                        if (document.getElementById('main-container-wrapper').classList.contains('is-full')) {
                            document.getElementById('main-container-wrapper').classList.remove('is-full');
                        }
                        this.showcatgories = true;
                        this.showBackButton = false;
                    }
                } else {
                    this.categories = [];
                    this.showcatgories = false;
                    this.fadeSearch = false;
                    setTimeout(() => {
                        this.showSearch = false;
                    }, 600);
                    this.searchModel = "";
                    this.searchText = "";
                }

                if (event.url.includes('/works/')) {
                    this.hiddeLogo = true;
                    if (this.screenWidth <= 1024) {
                        this.showBackButton = true;
                    }
                } else {
                    this.hiddeLogo = false;
                    this.showBackButton = false;
                }

                if (event.url == '/reels' || event.url.includes('/reels?')) {
                    this.wpApi.getReels().subscribe(resp => {
                        this.reels = resp;
                    })
                    this.showReels = true;
                } else {
                    this.showReels = false;
                }

                if (event.url == '/works/' || event.url.includes('/works/')) {
                    this.showSingleWorkTitle = true;
                } else {
                    this.showSingleWorkTitle = false;
                    this.singleWork = "";
                }
            }
        });
        this.wpApi.getMainMenu().subscribe(resp => {
            this.menus = resp.items;
        });
        this.wpApi.getSocialMenu().subscribe(resp => {
            this.socials = resp.items;
        });
        this.wpApi.getHeader().subscribe(resp => {
            this.content = resp[0].acf;
        });
        this.pageService.worksLoadedListen().subscribe(() => {
            setTimeout(() => {
                this.showBackButton = true;
            }, 300);
        })
        this.pageService.singleWorkListen().subscribe(resp => {
            this.singleWork = resp;
            this.showSingleWorkTitle = true;
        })

        this.pageService.activeReelListen().subscribe((reel) => {
            this.activeReelNumber = reel;
        })
        this.pageService.returnReelVideoExit().subscribe(() => {
            this.handleExitVideoButton();
        })
        this.wpApi.getContactInfo().subscribe(resp => {
            const data = resp;
            this.contactItems = data[0];
        })
        this.pageService.whiteLogoListen().subscribe((resp) => {
            this.whiteLogo = resp;
            this.bannerActive = resp;
        })
        this.pageService.loadPageListen().subscribe((resp) => {
            setTimeout(() => {
                this.changeLogo = true;
                this.whiteLoadMenu = false;
                this.menuDisabled = false;
            }, 600);
        })
        this.pageService.rotateLeftLogoListen().subscribe(() => {
            this.rotateValue += -120;
            this.rotateLogo(this.rotateValue);
        })
        this.pageService.rotateRightLogoListen().subscribe(() => {
            this.rotateValue += 120;
            this.rotateLogo(this.rotateValue);
        })
        this.pageService.removeSearchHeaderListen().subscribe(() => {
            this.fadeSearch = false;
            setTimeout(() => {
                this.showSearch = false;
            }, 600);
            this.searchModel = "";
            this.searchText = "";
        })
        this.pageService.activateMenuOverlayListen().subscribe((resp) => {
            this.activateMenuOverlay = resp;
        })
        this.getConnect();
        this.onResize();
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.screenWidth = window.innerWidth;
        if (this.screenWidth <= 1024 && window.location.pathname == '/') {
            this.whiteLogo = true;
        } else {
            this.whiteLogo = false;
        }
    }

    // @HostListener('document:click', ['$event.target'])
    // public onClick(target) {
    //     const menu = this.menu.nativeElement.contains(target);
    //     const menuButton = this.toggleButton.nativeElement.contains(target);
    //     if (this.screenWidth > 1024) {
    //         if (this.menuToggle && !menu && !menuButton) {
    //             this.toggleMenu();
    //         }
    //     }
    // }

    ngOnInit() {
        let theme = localStorage.getItem('theme');
        if(theme == 'dark') {
            this.darkTheme = true;
        }
        this.theme.setDarkTheme(this.darkTheme);
        
        this.screenWidth = window.innerWidth;
        if (this.screenWidth <= 1024 && window.location.pathname == '/') {
            this.whiteLogo = true;
        } else {
            this.whiteLogo = false;
        }
        this.whiteLoadMenu = true;
    }

    handleRouterLink(url) {
        const urlreplaced = url.replace('http://', '').replace('https://', '');
        return urlreplaced;
    }

    loadHeader() {
        if (window.location.pathname == '/') {
            this.loadMenu = true;
            this.loadPulla = true;
        } else {
            setTimeout(() => {
                this.loadMenu = true;
            }, 500);
            this.loadPulla = false;
        }
    }

    getCatgories() {
        this.wpApi.getCatgories().subscribe(resp => {
            this.categories = resp;
        })
    }

    getConnect() {
        this.wpApi.getFooter().subscribe(resp => {
            this.handleConnect(resp);
        });
    }

    handleConnect(resp) {
        this.connect = resp[0].acf;
    }

    activeReel(reel) {
        this.pageService.activeReel(reel);
        this.activeReelNumber = reel;
        if (reel == 0) {
            this.rotateValue = 0;
        } else if (reel == 1) {
            this.rotateValue = 120;
        } else if (reel == 2) {
            this.rotateValue = 240;
        }
        this.rotateLogo(this.rotateValue)
    }

   

    filterCase(id, slug, event) {
        let ctrlKey = event.ctrlKey || event.metaKey;
        if (slug === 'all' && this.screenWidth < 1024) {
            window.scrollTo(0, 0);
            this.setActiveFilter = "all work";
            this.activeAll = "all work";
        } else {
            this.setActiveFilter = slug;
            this.activeAll = slug;
        }

        if (this.screenWidth > 1024 && ctrlKey) {
            let url = window.location.href
            window.open(url + '?category=' + slug, "_blank");
        } else {
            this.categoryParams.id = id;
            this.categoryParams.slug = slug;
            this.toggleDropdown = false;
            this.categoriesmobile = [];
            this.pageService.getCategory(this.categoryParams);

            if (slug === 'all') {
                this.router.navigate(['/works']);
            } else {
                this.router.navigate(['/works'], { relativeTo: this.route, queryParams: { "category": slug, "search": null }, queryParamsHandling: 'merge' });
            }
        }
    }

    getBackItems() {
        if (this.body.classList.contains('hide-menu')) {
            this.body.classList.remove('hide-menu');
        }
    }

    showInfoDetail() {
        this.activeContactInfo = !this.activeContactInfo;
        setTimeout(() => {
            this.inquiresActive = !this.inquiresActive;
        }, 100);
        setTimeout(() => {
            this.careersActive = !this.careersActive;
        }, 150);
        setTimeout(() => {
            this.socialActive = !this.socialActive;
        }, 350);
    }

    toggleMenu(newPage = false) {
        if (!this.menuDisabled) {
            if (this.screenWidth <= 1024) {
                this.openMobileMenu = !this.openMobileMenu;
            }
            if (window.location.pathname == '/') {
                document.getElementById('not-active').classList.add('active');
                // if (this.screenWidth <= 1024 && this.bannerActive) {
                //     this.whiteLogo = true;
                // } else if (this.screenWidth <= 1024 && !this.menuToggle) {
                //     this.whiteLogo = true;
                // } else {
                // }
                this.whiteLogo = false;
            } else if (window.location.pathname == '/company') {
                document.getElementById('not-active').classList.remove('active');

                if (this.screenWidth <= 1024 && !this.companyLogoColor && this.menuToggle) {
                    this.whiteLogo = false;
                }
                if (this.whiteLogo) {
                    this.companyLogoColor = true;
                }
                if (this.screenWidth <= 1024 && !this.menuToggle) {
                    this.whiteLogo = false;
                } else if (this.companyLogoColor && this.menuToggle) {
                    this.whiteLogo = true;
                    this.companyLogoColor = false;
                } else {
                    this.whiteLogo = false;
                }
            } else {
                document.getElementById('not-active').classList.remove('active');
                // if (this.screenWidth <= 1024 && !this.menuToggle) {
                //     this.whiteLogo = true;
                // } else {
                    this.whiteLogo = false;
                // }
            }
            // if (window.location.pathname == '/reels' && this.toggleMenu && this.screenWidth <= 1024) {
            //     this.whiteLogo = true;
            // }
            // const fadeclasess = document.getElementsByClassName('fade-overlay-menu');
            var html = document.getElementsByTagName('html')[0];
            if (this.menuToggle) {
                this.pageService.activateMenuOverlay(false);
                this.pageService.stopScroll(false);
                html.classList.remove('menu-open');
            } else {
                this.pageService.activateMenuOverlay(true);
                this.pageService.stopScroll(true);
                html.classList.add('menu-open');
            }
            if (this.toggleDropdown) {
                this.toggleDropdownEvent();
            }
           
            if (this.menuToggle) {
                if(newPage){
                    setTimeout(() => {
                        this.menuToggle = false;
                    }, 200);
                    setTimeout(() => {
                        this.ActiveFirst = false;
                        this.ActiveSecond = false;
                        this.ActiveThird = false;
                        this.ActiveFourth = false;
                        this.ActiveFifth = false;
                        this.ActiveSix = false;
                        this.ActiveSeven = false;
                        this.ActiveEight = false;
                        this.ActiveNine = false;
                        this.ActiveTen = false;
                        this.ActiveEleven = false;
                        this.ActiveTwelve = false;
                        this.ActiveThirteen = false;
                        this.ActiveFourteen = false;
                    }, 850);
                } else {
                    this.menuToggle = false;
                    setTimeout(() => {
                        this.ActiveFirst = false;
                        this.ActiveSecond = false;
                        this.ActiveThird = false;
                        this.ActiveFourth = false;
                        this.ActiveFifth = false;
                        this.ActiveSix = false;
                        this.ActiveSeven = false;
                        this.ActiveEight = false;
                        this.ActiveNine = false;
                        this.ActiveTen = false;
                        this.ActiveEleven = false;
                        this.ActiveTwelve = false;
                        this.ActiveThirteen = false;
                        this.ActiveFourteen = false;
                    }, 650);
                }
            } else {
                this.menuToggle = true;
                if (this.screenWidth <= 1024) {
                    setTimeout(() => {
                        this.ActiveFirst = true;
                    }, 600);
                    setTimeout(() => {
                        this.ActiveSecond = true;
                    }, 700);
                    setTimeout(() => {
                        this.ActiveThird = true;
                    }, 800);
                    setTimeout(() => {
                        this.ActiveFourth = true;
                    }, 900);
                    setTimeout(() => {
                        this.ActiveFifth = true;
                    }, 1000);
                    setTimeout(() => {
                        this.ActiveSeven = true;
                    }, 500);
                } else {
                    setTimeout(() => {
                        this.ActiveFirst = true;
                    }, 500);
                    setTimeout(() => {
                        this.ActiveSecond = true;
                    }, 600);
                    setTimeout(() => {
                        this.ActiveThird = true;
                    }, 700);
                    setTimeout(() => {
                        this.ActiveFourth = true;
                    }, 800);
                    setTimeout(() => {
                        this.ActiveFifth = true;
                    }, 900);
                    setTimeout(() => {
                        this.ActiveSix = true;
                    }, 1000);
                    setTimeout(() => {
                        this.ActiveSeven = true;
                    }, 700);
                    setTimeout(() => {
                        this.ActiveEight = true;
                    }, 1000);
                    setTimeout(() => {
                        this.ActiveNine = true;
                    }, 1100);
                    setTimeout(() => {
                        this.ActiveTen = true;
                    }, 1200);
                    setTimeout(() => {
                        this.ActiveEleven = true;
                    }, 1300);
                    setTimeout(() => {
                        this.ActiveTwelve = true;
                    }, 1400);
                    setTimeout(() => {
                        this.ActiveThirteen = true;
                    }, 1500);
                    setTimeout(() => {
                        this.ActiveFourteen = true;
                    }, 1600);
                }
            }
            this.pageService.activeMenu(this.menuToggle);
        }
    }

    search(e): void {
        if (this.searchModel != '') {
            this.searchText = this.searchModel;
            if (this.router.url.indexOf('/works/') > -1) {
                setTimeout(() => {
                    this.searchService.filter(this.searchModel);
                }, 1000);
            } else {
                this.searchService.filter(this.searchModel);
            }
          
            this.menuToggle = false;
            this.pageService.activeMenu(this.menuToggle);
            // const fadeclasess = document.getElementsByClassName('fade-overlay-menu');
            this.pageService.activateMenuOverlay(false);
            this.pageService.stopScroll(false);
            this.router.navigate(['/works'], { relativeTo: this.route, queryParams: { "search": this.searchModel, "category": null }, queryParamsHandling: 'merge' });
            this.pageService.goToTop();
        } else {
            this.fadeSearch = false;
            setTimeout(() => {
                this.showSearch = false;
            }, 600);
            this.searchModel = "";
            this.searchText = "";
            this.router.navigate(['/works']);
            this.pageService.removeSearch();
        }
        this.searchInputOnBlur();
    }

    public initAnimations() {
        let location = this.location.pathname.split('/');
        if (location[2] !== undefined) {
            if (location[1] === 'article') {
                this.animationService.animationArticleCalled(location[2]);
            } else {
                this.animationService.animationCalled(location[2]);
            }
        }
        setTimeout(() => {
            this.router.navigate(['/']);
        }, 200);
    }

    imageEventHandler() {
        this.animationService.initEventOnHeader();
    }

    imageEventHandlerBack() {
        this.animationService.initEventOnHeader();
    }

    toggleCategoriesDropdownEventMobile() {
        if (this.toggleDropdown) {
            this.toggleDropdownEvent();
        }
    }

    public setTitle(newTitle: string) {
        this.titleService.setTitle(newTitle);
    }

    toggleMenuOpened() {
        // const fadeclasess = document.getElementsByClassName('fade-overlay-menu');
        this.pageService.activateMenuOverlay(false);
        this.pageService.stopScroll(false);

        if (this.screenWidth <= 1024) {
            this.menuToggle = false;
        }

        if (this.screenWidth <= 1024) {
            this.whiteLogo = true;
        }
        // this.pageService.activeMenu(this.menuToggle);
    }

    handleExitVideoButton() {
        this.showExitVideoButton = true;
        this.hiddeLogo = true;
    }

    exitReelVideo() {
        this.showExitVideoButton = false;
        this.hiddeLogo = false;
        this.pageService.closeReelVideo();
    }

    toggleDropdownEvent() {
        this.toggleDropdown = !this.toggleDropdown;
        if (this.toggleDropdown == true) {
            this.categoriesmobile = this.categories
        } else {
            this.categoriesmobile = [];
        }
    }

    rotateLogo(value) {
        document.getElementById('rotate-logo').style.transform = 'rotate(' + value + 'deg)';
        document.getElementById('rotate-white-logo').style.transform = 'rotate(' + value + 'deg)';
    }

    goToTop() {
        if (window.location.pathname == '/') {
            this.pageService.goToTop();
        }
    }

    // toggleConnectMobile() {
    //     const element = document.getElementById('footer');
    //     element.scrollIntoView();
    //     setTimeout(() => {
    //         this.toggleMenu();
    //     }, 100);
    // }

    searchInputOnFocus() {
        this.searchingOnFocus = true;
        this.searchModel = "";
    }

    searchInputOnBlur() {
        this.searchingOnFocus = false;
        this.searchModel = "";
    }

    menuOnHover(i){
        if (this.screenWidth > 1024) {
            this.activeImage = i;
        }
    }
    
    menuOnHoverOut(){
        if (this.screenWidth > 1024) {
            this.activeImage = this.activeMenuItem;
        }
    }

    toggleTheme(){
        this.darkTheme = !this.darkTheme
        this.theme.setDarkTheme(this.darkTheme);
    }

}